export default __webpack_public_path__ + "static/media/IQVIA.1846a822.svg";